import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ICommendaNexus } from './types';

export function useSalesTaxNexus({
  token,
  filters,
}: {
  token: string;
  filters: {
    corporationId: number;
  };
}) {
  const query = new URLSearchParams();

  if (filters.corporationId) {
    query.append('corporationId', filters.corporationId?.toString());
  }

  const {
    data,
    mutate,
    error,
    isLoading,
  }: {
    data?: { data: ICommendaNexus[] };
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    `new-sales-tax/nexus?${query}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: data?.data,
    mutate,
    error,
    isLoading,
  };
}
